import { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faShareNodes, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

export default function CopyLinkButton({ href }: { href?: string }) {
  const [copied, setCopied] = useState(false);
  const [failed, setFailed] = useState(false);
  const timer = useRef<number | null>(null);

  useEffect(
    () => () => {
      if (timer.current !== null) window.clearTimeout(timer.current);
    },
    [],
  );

  const flash = (ok: boolean) => {
    setCopied(ok);
    setFailed(!ok);
    if (timer.current !== null) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => {
      setCopied(false);
      setFailed(false);
    }, 2000);
  };

  const copy = async () => {
    const link = href ?? window.location.href;
    try {
      await navigator.clipboard.writeText(link);
      if (href) window.history.replaceState(null, '', href);
      flash(true);
    } catch {
      flash(false);
    }
  };

  const title = copied ? 'Link copied' : failed ? 'Failed to copy' : 'Copy link';

  return (
    <button
      type={'button'}
      className={'btn btn-sm text-muted'}
      onClick={() => void copy()}
      title={title}
      aria-label={title}
    >
      <FontAwesomeIcon icon={copied ? faCheck : failed ? faTriangleExclamation : faShareNodes} />
    </button>
  );
}
